// extracted by mini-css-extract-plugin
export default {"checkoutModal":"CheckoutModal_checkoutModal__j2GLG"};